import { motion } from 'motion/react';

export const MenuBack = () => {
  return (
    <motion.div
      className="pointer-events-none fixed bottom-0 left-0 right-0 top-0 z-30 bg-black"
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
        transition: {
          delay: 0.5,
        },
      }}
    />
  );
};
